import { render, staticRenderFns } from "./get-single-group.vue?vue&type=template&id=cea0c38a&"
import script from "./get-single-group.vue?vue&type=script&lang=js&"
export * from "./get-single-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports